import { Component, OnInit } from '@angular/core';
import { ResultData } from 'src/app/_models/ResultData';
import { RoleGroupService } from 'src/app/_services/role-group.service';

@Component({
  selector: 'app-role-group-index',
  templateUrl: './role-group-index.component.html',
  styleUrls: ['./role-group-index.component.css']
})
export class RoleGroupIndexComponent implements OnInit {


  roleGroups=undefined
  dtOptions: DataTables.Settings = {};
  loading = false

  constructor( private roleGroupService:RoleGroupService) { }

  ngOnInit(): void {
    this.loading=true
    this.dtOptions = {
      pagingType: 'full_numbers'
     };


    this.roleGroupService.getRoleGroups().subscribe(
      {
        next:(x:ResultData)=>{
        this.roleGroups=x.rs.data
        console.log(this.roleGroups)
        this.loading=false
      }


  })
}
}

